import { Component, Input, OnInit } from '@angular/core';

import { VColor } from '../../../modules/sanna/data/models/constants.interface';

@Component({
  selector: 'app-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent implements OnInit {
  /** Muestra o no este componente de acuerdo a este valor */
  @Input() loading: boolean;

  /** color del elemento mostrado */
  @Input() color: VColor;

  constructor() {
    this.loading = false;
    this.color = 'dark';
  }

  ngOnInit() {}
}
